import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { FaEdit, FaTrash } from "react-icons/fa";
import EditFunctionPopup from "../popups/EditFunctionPopup";
import ConfirmationPopup from "../popups/ConfirmationPopup";
import ToastPopup from "../popups/ToastPopup";
import { FunctionData, FunctionEnum, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import EncryptionUtils from "../main/encryptionUtils";
const Functions: React.FC = () => {
    const [data, setData] = useState<FunctionData[]>([]);
    const [, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [selectedFunction, setSelectedFunction] = useState<FunctionData | null>(null);
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
    const [fields, setFields] = useState<any>({});
    const navigate = useNavigate();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [functionToDelete, setFunctionToDelete] = useState<string | null>(null);
    const [message, setMessage] = useState<ToastMessage | null>(null);
    const [functionEnums, setFunctionEnums] = useState<FunctionEnum[]>([]);
    const clientId = localStorage.getItem("clientId");
    const columns = [{ key: "functionName", label: "Function Name" }, { key: "functionHeadName", label: "Function Head Name" }, { key: "functionHeadEmail", label: "Function Head Email" }, { key: "functionSpocName", label: "Function Spoc Name" }, { key: "functionSpocEmail", label: "Function Spoc Email" }, { key: "status", label: "Status" }, { key: "createdDate", label: "Created Date" }, { key: "createdBy", label: "Created By" }, { key: "updateDate", label: "Updated Date" }, { key: "updatedBy", label: "Updated By" }];
    useEffect(() => {
        const permissions = EncryptionUtils.get<any>("permissions", null);
        if (permissions.tabs && permissions.tabs["functions"]) {
            setFields(permissions.tabs["functions"].fields);
        } else {
            console.log("No permissions found for 'functions' tab");
        }
    }, []);
    useEffect(() => {
        const fetchFunctionEnums = async () => {
            try {
                const response = await apiCall("get", "/api/enums/FunctionEnum");
                setFunctionEnums(response || []);
            } catch (error) {
                console.error("Error fetching function enums:", error);
            }
        };
        fetchFunctionEnums();
    }, []);
    const getFunctionDescription = (value: string) => {
        const enumItem = functionEnums.find(item => item.value === value);
        return enumItem ? enumItem.description : value || "N/A";
    };
    const formatDate = (dateString: string | undefined | null): string => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }
    const fetchFunctions = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/functions?status=ACTIVE&clientId=${clientId}&page=${currentPage - 1}&size=${itemsPerPage}`);
            setData(response?.content || []);
            setTotalPages(response?.totalPages || 0);
            setTotalElements(response?.totalElements || 0);
        } catch (error) {
            console.error("Error fetching functions:", error);
        } finally {
            setLoading(false);
        }
    }, [clientId, currentPage, itemsPerPage]);
    const fetchAllFunctions = async (): Promise<FunctionData[]> => {
        try {
            const response = await apiCall("get", `/api/functions?status=ACTIVE&clientId=${clientId}&page=0&size=${totalElements}`);
            const transformedData = (response?.content || []).map((func: { functionName: string; }) => ({
                ...func, functionName: getFunctionDescription(func.functionName) || "N/A",
            }));
            return transformedData;
        } catch (error) {
            console.error("Failed to export functions. Please try again later.");
            return [];
        }
    };
    useEffect(() => { fetchFunctions(); }, [fetchFunctions]);
    const handleEditClick = (functionData: FunctionData) => {
        setSelectedFunction(functionData);
        setIsPopupOpen(true);
    }
    const handleDeleteClick = (functionId: string) => {
        setFunctionToDelete(functionId);
        setShowDeleteConfirmation(true);
    };
    const confirmDelete = async () => {
        if (!functionToDelete) return;
        try {
            await apiCall("patch", `/api/functions?status=INACTIVE`, [functionToDelete]);
            await fetchFunctions();
            setMessage(createToastMessage("Function deleted successfully!", "success", 3000));
            setTimeout(() => window.location.reload(), 3000);
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || "Failed to delete function";
            setMessage(createToastMessage(errorMessage, "error", 3000));
        } finally {
            setShowDeleteConfirmation(false);
            setFunctionToDelete(null);
        }
    };
    const handleClosePopup = () => { setIsPopupOpen(false); setSelectedFunction(null) };
    const handleCreateFunction = () => {
        navigate("/createfunction");
    };
    const handleAddFunction = () => {
        navigate("/addfunction");
    };
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Functions</h2>
                <div className="table-title-actions">
                    {fields.create && (
                        <button className="campaign-funtion" onClick={() => handleCreateFunction()}>Create Function</button>
                    )}
                    {fields.view && (
                        <button className="campaign-create" onClick={() => handleAddFunction()}> Add Function</button>
                    )}
                    <ExportButton data={data} columns={columns} fetchAllData={fetchAllFunctions} fileName="functions" />
                </div>
            </div>
            <div>
                <div className="table-container">
                    <div className="table-inner-container">
                        <table className="main-table">
                            <thead>
                                <tr>
                                    {columns.map((column) => (
                                        <th key={column.key}>{column.label}</th>
                                    ))}
                                    {fields.edit && (<th>Actions</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((func) => (
                                        <tr key={func.functionId}>
                                            <td>{getFunctionDescription(func.functionName || "N/A")}</td>
                                            <td>{func.functionHeadName || "N/A"}</td>
                                            <td>{func.functionHeadEmail || "N/A"}</td>
                                            <td>{func.functionSpocName || "N/A"}</td>
                                            <td>{func.functionSpocEmail || "N/A"}</td>
                                            <td>{func.status || "N/A"}</td>
                                            <td>{formatDate(func.createdDate) || "N/A"}</td>
                                            <td>{func.createdBy || "N/A"}</td>
                                            <td>{formatDate(func.updateDate) || "N/A"}</td>
                                            <td>{func.updatedBy || "N/A"}</td>
                                            <td>
                                                {fields.edit && (
                                                    <FaEdit className="action-button" onClick={() => handleEditClick(func)} title="Edit Function" />)}
                                                {fields.delete && (
                                                    <FaTrash className="action-button" onClick={() => handleDeleteClick(func.functionId)} title="Delete Function" />
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={columns.length + 1} className="no-data">No functions found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
            </div>
            {isPopupOpen && selectedFunction && (
                <EditFunctionPopup functionData={selectedFunction} onClose={handleClosePopup} onUpdateSuccess={fetchFunctions} />
            )}
            {showDeleteConfirmation && (
                <ConfirmationPopup message="Are you sure you want to delete this function?" onConfirm={confirmDelete} onCancel={() => setShowDeleteConfirmation(false)} />
            )}
            {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => { setMessage(null); }} />)}
        </div>
    );
};
export default Functions;